import { put, takeLatest } from "@redux-saga/core/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import { handleNotificationAlertCatch, handleNotificationAlertTrySelect } from "../../../common/method/handleNotificationAlert";



export const actionTypes = {
    selectPortfolioHistory: "[selectPortfolioHistory] Action",
    selectPortfolioHistoryEmpty: "[selectPortfolioHistoryEmpty] Action",
    selectPortfolioHistoryAsync: "[selectPortfolioHistoryAsync] Action",
    selectPortfolioHistoryLoading: "[selectPortfolioHistoryLoading] Action",
}



const initialState = {
    data: [],
    loading: false,
    total:0
}

export const select_portfolio_history_reducer = (state = initialState, { type, payload }) => {

    switch (type) {
        case actionTypes.selectPortfolioHistory:
            return {
                ...state,
                data: payload?.data?.results ? payload?.data?.results : [],
                total:payload?.data?.total ? payload?.data?.total : 0,
            }
        case actionTypes.selectPortfolioHistoryEmpty:
            return {
                ...state,
                data: []
            }
        case actionTypes.selectPortfolioHistoryLoading:
            return {
                ...state,
                loading: payload,
            }
        default:
            return state;
    }
}




function* handleWorker({ payload }) {

    yield put({ type: actionTypes.selectPortfolioHistoryLoading, payload: true })

   



    let config = {
        url: "select_request"
    };

    let data = {
        table: "portfolio",
        method_type: "select_portfolio_history",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
          return;
        }
        yield put({ type: actionTypes.selectPortfolioHistory, payload: res?.data?.response })
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.selectPortfolioHistoryLoading, payload: false })

    }
}

export function* selectPortfolioHistory() {
    yield takeLatest(actionTypes.selectPortfolioHistoryAsync, handleWorker);
}
